<script setup>
import { defineProps, defineEmits } from "vue";
defineProps({
  tabs: {
    type: Array,
    required: true,
    validator: (tabs) => {
      return tabs.every((tab) => {
        return ["id", "href", "controls", "label", "isActive"].every(
          (key) => key in tab
        );
      });
    },
  },
});

defineEmits(["tab-click"]);
</script>

<template>
  <ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
    <li v-for="tab in tabs" :key="tab.id" class="nav-item" role="presentation">
      <a
        class="nav-link"
        :class="{ active: tab.isActive }"
        :id="tab.id"
        @click.prevent="$emit('tab-click', tab.id)"
        :href="tab.href"
        role="tab"
        :aria-controls="tab.controls"
        :aria-selected="tab.isActive"
        >{{ tab.label }}</a
      >
    </li>
  </ul>
</template>
